import React, { FC, ReactNode } from "react"
import { HR, Spacer } from "components/views/atoms/Atoms"

type HeaderProps = {
  titleBar?: ReactNode
  children?: ReactNode
  id?: string
}

const Header: FC<HeaderProps> = ({ titleBar, children, id }) => (
  <div id={id} className="flex flex-column justify-end w-100 h-192-ns">
    <div className="db dn-l">
      <Spacer height={2.375} />
    </div>
    <div>{children || titleBar}</div>
    <div className="w-100 mt3">
      <HR color={"black-20"} />
    </div>
  </div>
)
export { Header }
